var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vm-markdown-html"},[(_vm.value != '')?_c('pre',[_vm._v(_vm._s(_vm.value))]):_c('div',[_vm._v("Yükleniyor...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }